import { createSelector } from 'reselect';
import { IContentDetail, IStoreState } from 'src/interface';

export const isLargeFontSize = (state: IStoreState) => state.content.largeFont;
export const getContentsSelector = (state: IStoreState) =>
    state.content.contents || {};

export const getContentSelector = (contentId: number) => (
    state: IStoreState
): IContentDetail | undefined => {
    if (!state.content.contents) {
        return undefined;
    }

    return state.content.contents[contentId];
};

export const currentContentIdSelector = (state: IStoreState): number =>
    state.content.contentCurrentId;

export const isFetchingSelector = (state: IStoreState): boolean =>
    state.content.isFetching;

export const currentContentSelector = createSelector(
    currentContentIdSelector,
    getContentsSelector,
    (currentContentId, contents): IContentDetail | undefined => {
        return contents[currentContentId];
    }
);

export const isOpenSelector = (state: IStoreState) => state.content.isOpen;
